// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

// Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const SIGNIN_USER_ERROR = 'signin_user_error';

export const SERVER_LOGIN = 'server/login';
export const SERVER_LOGIN_WITH_TOKEN = 'server/login_with_token';
export const SERVER_LOG_OUT = 'server/log_out';
export const SERVER_RESTORE_PASSWORD = 'server/restore_password';
export const TOKEN_EXPIRED = 'token_expired';

// General const

export const CONSOLE = 'console';
export const SERVER_GET_INITITIAL_APP_SETUP = 'server/get_initial_app_setup';
export const SET_USER_LIST = 'set_user_list';
export const SET_REPORT_TYPES = 'set_report_types';
export const SUCCESS_NOTIFICATION = 'success_notification';
export const ERROR_NOTIFICATION = 'error_notification';
export const SERVER_CREATE_NEW_USER = 'server/create_new_user';
export const SERVER_UPDATE_USER_DATA = 'server/update_user_data';
export const ADD_USER = 'add_user';
export const UPDATE_USER = 'update_user';
export const SET_USER_PROFILE = 'set_user_profile';
export const SET_RESPONSIBLE_AREAS = 'set_responsible_areas';
export const SET_NOTIFICATIONS = 'set_notifications';
export const SERVER_DELETE_USER = 'server/delete_user';
export const DELETE_USER = 'delete_user';

// Reports const

export const SERVER_GET_REPORTS = 'server/get_reports';
export const SET_REPORTS = 'set_reports';

export const SERVER_GET_REPORT_DETAILS = 'server/get_report_details';
export const SET_REPORT_DETAILS = 'set_report_details';

export const SERVER_COMPLETE_REPORT = 'server/complete_report';
export const SERVER_DELETE_REPORT = 'server/delete_report';
export const SERVER_RESTORE_REPORT = 'server/restore_report';
export const UPDATE_REPORT_STATUS = 'update_report_status';
export const SERVER_REMOVE_REPORT_IN_PROCESS = 'server/remove_report_in_process';
export const SERVER_SET_REPORT_IN_PROCESS = 'server/set_report_in_process';
export const SERVER_ASSIGN_USER_TO_REPORT = 'server/assign_user_to_report';
export const ASSIGN_REPORT_TO_USER = 'assign_report_to_user';

export const SERVER_ADD_USER_COMMENT = 'server/add_user_comment';
export const ADD_USER_COMMENT = 'add_user_comment';



// WEBPACK FOOTER //
// ./constants/ActionTypes.js